var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M17.97621,.8803c1.05634-1.12792,2.81935-1.17869,3.93778-.11339,.03854,.03671,.07603,.07452,.11243,.11339l17.21479,18.38339c1.05536,1.12886,1.00348,2.90677-.11588,3.97109-.51648,.49108-1.19938,.76479-1.90922,.76522H2.78652C1.2481,24.00053,.00053,22.74324,0,21.19177c-.00024-.71812,.27222-1.40906,.76141-1.93088L17.97621,.8803Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.fbfd7ef41fd5ec6788cec8d6c4eee0e7.svg";
export { ForwardRef as ReactComponent };